import React, { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { api } from "./lib/api";
import { ScrollManager, AppBar, Logo, INSTAGRAM } from "./components/Layout";
import PageMeta from "./components/PageMeta";
import Home from "./pages/Home";
import Book from "./pages/Book";
import Leagues from "./pages/Leagues";
import Manage from "./pages/Manage";
import Login from "./pages/Login";
import { AdminBookings, StaffBookings } from "./pages/Bookings";

const IS_UNDER_MAINTENANCE = false; // set to true to close the public pages
const MAINTENANCE_MESSAGE = "Vibe & Volley is temporarily unavailable as we are undergoing a facelift! Keep an eye on our Instagram handle for updates!";

function MaintenancePage() {
  return (
    <div className="vv-page vv-maint" data-vv-surface="hero">
      <div className="vv-maint__card">
        <Logo size="lg" />
        <h1 className="vv-display vv-h1">Court under maintenance</h1>
        <p>{MAINTENANCE_MESSAGE}</p>
        <a href={INSTAGRAM.href} target="_blank" rel="noopener noreferrer" className="vv-btn vv-btn--accent">
          Follow {INSTAGRAM.label}
        </a>
      </div>
    </div>
  );
}

const publicPage = (el) => (IS_UNDER_MAINTENANCE ? <MaintenancePage /> : el);

// Asks the server who this session belongs to; the cookie is the only gate.
function ProtectedRoute({ children, allow = ["admin"] }) {
  const [state, setState] = useState("checking");
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;
    api("session")
      .then((r) => {
        if (!cancelled) setState(r.role && allow.includes(r.role) ? "ok" : "denied");
      })
      .catch(() => {
        if (!cancelled) setState("denied");
      });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (state === "checking") {
    return (
      <div className="vv-page vv-page--paper">
        <AppBar />
        <main className="vv-wrap vv-dash"><p className="vv-muted">Checking access…</p></main>
      </div>
    );
  }
  if (state === "denied") {
    // Carry the intended destination through the login round-trip, otherwise
    // someone asking for /staff is silently handed /admin instead.
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}

export default function App() {
  return (
    <Router>
      <ScrollManager />
      <PageMeta />
      <Routes>
        <Route path="/" element={publicPage(<Home />)} />
        <Route path="/book" element={publicPage(<Book />)} />
        <Route path="/leagues" element={publicPage(<Leagues />)} />
        <Route path="/manage" element={publicPage(<Manage />)} />

        {/* Login is public; /admin and /staff require a server session */}
        <Route path="/login" element={<Login />} />
        <Route path="/staff" element={<ProtectedRoute allow={["staff", "admin"]}><StaffBookings /></ProtectedRoute>} />
        <Route path="/admin" element={<ProtectedRoute><AdminBookings /></ProtectedRoute>} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}
